"use client";

import { usePathname } from "next/navigation";

/** Nasconde la chrome interna (header/splash/workloads) sui moduli pubblici (es. /critterz),
 *  che hanno UI propria. I children sono server-rendered e passati attraverso: nessun problema
 *  con le server action. */
export default function HideOnPublic({ children }: { children: React.ReactNode }) {
  const path = usePathname();
  if (path?.startsWith("/critterz")) return null;
  return <>{children}</>;
}
